var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants.js');
var NetworkManager = require('./NetworkManager.js');
var LinkingManager = require('./wrappers/LinkingManager');
var dismissKeyboard = require('react-native-dismiss-keyboard');

var Icon = require('./wrappers/ReUpIcon');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpField = require('./ReUpField.js')
var ReUpButton = require('./ReUpButton.js')
var ReUpStyle = require('./ReUpStyle.js')
var ReUpText = require('./ReUpText.js');
var ShadowView = require('./ShadowView.js');
var ProgressOverlay = require('./ProgressOverlay.js');
var LinkingManager = require('./wrappers/LinkingManager');
var AnalyticsManager = require('./AnalyticsManager');
var Hyperlink = require('./wrappers/react-native-hyperlink-wrapper');
var AddToWalletButton = require('./AddToWalletButton');
var OffsetView = require('./OffsetView');
var createReactClass = require('create-react-class');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKIconToggle,
  MKCheckbox,
  MKButton,
  MKSpinner
} = MK;

var {
  AppRegistry,
  Text,
  View,
  StyleSheet,
  AppState,
  Platform,
  Image
} = ReactNative;

var SimpleLogin = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      didCompleteRegistration : ()=>{},
      userName: null,
      storeFocus : ()=>{},
    }
  },

  getInitialState : function()
  {
    var shouldDrawPage = [true, false, false];
    if( typeof this.props.extras !== 'undefined'
      && typeof this.props.extras.userName !== 'undefined' )
    {
      shouldDrawPage = [false, true, false];
    }
    return {
      layout : this.props.initialLayout,
      showPassword : false,
      nameError : false,
      firstNameError : false,
      lastNameError : false,
      emailError : false,
      emailErrorString: 'Please use a valid email',
      passwordError : false,
      shouldShowSpinner: false,
      spinnerText: '',
      optedIn: false,
      showNameDoneButton: false,
      showEmailDoneButton: false,
      showPasswordDoneButton: false,
      spinnerTitle:"",
      spinnerBody:"",
      shouldDrawPage
    }
  },

  componentDidMount : function()
  {
    if( typeof this.props.extras !== 'undefined'
      && typeof this.props.extras.userName !== 'undefined' )
    {
      if( this._emailField ) this._emailField.setText(this.props.extras.userName);
      this._email = this.props.extras.userName;
      this.goToPage(1, 1);
    }
    else
    {
      this.focus();
    }
  },

  componentWillUnmount : function()
  {

  },

  didUpdate : function(data)
  {
  },

  focus : function()
  {
    if( this._ref_firstName ) this._ref_firstName.focus();
  },

  _email : "",
  emailChanged : function(text)
  {
    if( this.props.appManager.isValidEmail(text) ) this._enableEmailError = true;
    this._email = text;

    var newState = this.checkErrors();
    newState.showEmailDoneButton = this._email.length > 0;
    if ( this.state.emailError != newState.emailError
      || this.state.showEmailDoneButton !== newState.showEmailDoneButton )
    {
      this.setState(newState);
    }
  },

  _firstName : "",
  firstNameChanged : function(text)
  {
    var firstNameValid = this._firstName.length > 0;
    if( firstNameValid ) this._enableFirstNameError = true;

    this._firstName = text;
    var newState = this.checkErrors();
    newState.showNameDoneButton = this._firstName.length > 0 && this._lastName.length > 0;
    if ( this.state.firstNameError !== newState.firstNameError
      || this.state.showNameDoneButton !== newState.showNameDoneButton)
    {
      this.setState(newState);
    }
  },

  _lastName : "",
  lastNameChanged : function(text)
  {
    var lastNameValid = this._lastName.length > 0;
    if( lastNameValid ) this._enableLastNameError = true;

    this._lastName = text;
    var newState = this.checkErrors();
    newState.showNameDoneButton = this._firstName.length > 0 && this._lastName.length > 0;
    if ( this.state.lastNameError !== newState.lastNameError
      || this.state.showNameDoneButton !== newState.showNameDoneButton )
    {
      this.setState(newState);
    }
  },

  _password : "",
  passwordChanged : function(text)
  {
    if( this.props.appManager.isValidPassword(text) ) this._enablePasswordError = true;

    this._password = text;
    var newState = this.checkErrors();
    newState.showPasswordDoneButton = this._password.length > 0;
    if ( this.state.passwordError != newState.passwordError
      || this.state.showPasswordDoneButton !== newState.showPasswordDoneButton)
    {
      this.setState(newState);
    }
  },

  _refCode : "",
  refCodeChanged: function(text)
  {
    this._refCode = text;
  },

  _enableFirstNameError : false,
  _enableLastNameError : false,
  _enableEmailError : false,
  _enablePasswordError : false,
  _enableInlineErrors : false,
  checkErrors : function()
  {
    var firstNameError = this._enableFirstNameError && !this._firstName.length > 0;
    var lastNameError = this._enableLastNameError && !this._lastName.length > 0;
    var emailError = this._enableEmailError && !this.props.appManager.isValidEmail(this._email);
    var passwordError = this._enablePasswordError && !this.props.appManager.isValidPassword(this._password);

    return {emailError:emailError, firstNameError:firstNameError, lastNameError:lastNameError, passwordError:passwordError};
  },

  showRefCodeField: function()
  {
    var thisThing = this;
    thisThing.setState({showRefCode: !thisThing.state.showRefCode})
    Animated.timing(
      this.state.fadeRefCode,
      {
        toValue: 1,
        duration: 500,
      },
    ).start(function()
    {
      thisThing._ref_refCode.focus();
    });
  },

  showEmailSpinnerAndMessage: function(email)
  {
    var thisThing = this;
    var locMan = this.props.appManager.getLocalizationManager();
    var spinnerText = locMan.localizedStringForKey("VERIFY_YOUR_ACCOUNT_TITLE", "Verify Your Account");
    var spinnerBody = locMan.localizedStringForKeyAndParams("VERIFY_YOUR_ACCOUNT_SMS_BODY", [], 'We have sent you a text message. Please check your text messages and tap the link to access your account.');
    this.checkForMailApp((can)=>
    {
      thisThing.showSpinnerAndMessage(spinnerText, spinnerBody, can);
    })
  },

  showSpinnerAndMessage: function(spinnerTitle, spinnerBody)
  {
    dismissKeyboard();
    this.goToPage(2);
    this.setState({shouldShowSpinner: true, spinnerTitle, spinnerBody})
  },

  hideSpinnerAndMessage: function()
  {
    this.setState({shouldShowSpinner: false})
  },

  _currentPageNum: 0,
  goToPage: function(pageNum, animated)
  {
    // if( typeof this._pageContainer.scrollTo !== 'undefined' ) this._pageContainer.scrollTo(0,0);
    if( this._currentPageNum == pageNum ) return;
    this._currentPageNum = pageNum;

    if( typeof animated === 'undefined' ) animated = true;

    var newOffset = pageNum*this.props.initialLayout.width;

    var shouldDrawPage = this.state.shouldDrawPage;
    shouldDrawPage[pageNum] = true;
    this.setState({shouldDrawPage});
    this.storeFocus();

    var thisThing = this;
    if( this._pageContainer != null )
    {
      this._pageContainer.scrollTo({x:newOffset, animated, completion:()=>
      {
        var fieldToFocus = null;
        if( pageNum == 0 ) fieldToFocus = thisThing._emailField;
        if( pageNum == 1 ) fieldToFocus = thisThing._passwordField;
        if( fieldToFocus != null ) fieldToFocus.focus();
        thisThing.setState({shouldDrawPage:[pageNum == 0,pageNum == 1,pageNum == 2]});
      }});
    }
  },

  storeFocus: function()
  {
    if( typeof this.props.extras !== 'undefined'
      && typeof this.props.extras.storeFocus !== 'undefined')
    {
      this.props.extras.storeFocus();
    }
  },

  submitPressed : function()
  {
    this._enableEmailError = true;
    this._enablePasswordError = true;

    var newState = this.checkErrors();
    this.setState(newState);
    var thisThing = this;
    var appActions = this.props.appActions;

    if( newState.emailError )
    {
      this.goToPage(0);
    }
    else if( newState.passwordError )
    {
      this.goToPage(1);
    }
    else
    {
      var appManager = this.props.appManager;
      var email = this._email;
      var password = this._password;
      var locManager = this.props.appManager.getLocalizationManager();

      NetworkManager.login(thisThing.props.appManager, thisThing._email, thisThing._password, (data)=>
      {
        AnalyticsManager.logLoginEvent(appManager, 'PassPortal', true);
        data[ModelConstants.Password] = password;
        appManager.setCurrentUser(data, function()
        {
          thisThing.loginComplete();
        })
      }, function(data)
      {
        thisThing._password = "";
        AnalyticsManager.logLoginEvent(appManager, 'regular', false);
        if( data.code == -23 ) // not verified
        {
          appActions.showLocalizedAlert("UNVERIFIED_FAIL_ALERT_TITLE", "UNVERIFIED_FAIL_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [appActions.hideAlert, function()
          {
            NetworkManager.resendVerifyEmail(appManager, thisThing._email, function()
            {
              if( typeof thisThing.props.extras !== 'undefined'
                && typeof thisThing.props.extras.userName !== 'undefined' )
              {
                thisThing.goToPage(1);
              }
              else
              {
                thisThing.goToPage(0);
              }
              appActions.showLocalizedAlert("EMAIL_PASS_SUCCESS_ALERT_TITLE", "CREATEUSER_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
            }, function()
            {
              if( typeof thisThing.props.extras !== 'undefined'
                && typeof thisThing.props.extras.userName !== 'undefined' )
              {
                thisThing.goToPage(1);
              }
              else
              {
                thisThing.goToPage(0);
              }
              appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert)
            }, function()
            {
              if( typeof thisThing.props.extras !== 'undefined'
                && typeof thisThing.props.extras.userName !== 'undefined' )
              {
                thisThing.goToPage(1);
              }
              else
              {
                thisThing.goToPage(0);
              }
              appActions.showNetworkErrorAlert(appActions.hideAlert, function(){});
            })
          }], ()=>
          {
            if( typeof thisThing.props.extras !== 'undefined'
              && typeof thisThing.props.extras.userName !== 'undefined' )
            {
              thisThing.goToPage(1);
            }
            else
            {
              thisThing.goToPage(0);
            }
            appActions.hideAlert()
          });
        }
        else
        {
          appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [()=>
          {
            appActions.hideAlert();
            if( typeof thisThing.props.extras !== 'undefined'
              && typeof thisThing.props.extras.userName !== 'undefined' )
            {
              thisThing.goToPage(1);
            }
            else
            {
              thisThing.goToPage(0);
            }
          }], ()=>
          {
            if( typeof thisThing.props.extras !== 'undefined'
              && typeof thisThing.props.extras.userName !== 'undefined' )
            {
              thisThing.goToPage(1);
            }
            else
            {
              thisThing.goToPage(0);
            }
            appActions.hideAlert()
          });
        }
      }, function(data)
      {
        if( typeof thisThing.props.extras !== 'undefined'
          && typeof thisThing.props.extras.userName !== 'undefined' )
        {
          thisThing.goToPage(1);
        }
        else
        {
          thisThing.goToPage(0);
        }
        AnalyticsManager.logLoginEvent(appManager, 'Normal', false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
      })
    }
  },

  openTosLink: function(url)
  {
    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
    LinkingManager.canOpenURL(url, function(can)
    {
      if( can )
      {
        LinkingManager.openURL(url, tintColor, barTintColor)
      }
    });
  },

  _recursiveLoginPaused: false,
  setRecursiveLoginPaused: function(paused)
  {
    if( paused != this._recursiveLoginPaused )
    {
      if( paused ) // can only pause if there is login info recorded
      {
        if( this._loginInfoForPause != null )
        {
          this._recursiveLoginPaused = paused;
          clearTimeout(this._recursiveLoginTimeout);
        }
      }
      else
      {
        this._recursiveLoginPaused = paused;
        if( this._loginInfoForPause != null ) // can only resume if login info is recorded
        {
          this.recursiveLogin(this._loginInfoForPause.appManager, this._loginInfoForPause.email, this._loginInfoForPause.password, this._loginInfoForPause.didLogin )
        }
      }
    }
  },

  _shouldContinueRecuriveLogin : false,
  _recursiveLoginTimeout : null,
  _loginInfoForPause:null,
  recursiveLogin: function(appManager, email, password, didLogin)
  {
    if( !this._shouldContinueRecuriveLogin || this._recursiveLoginPaused ) return;

    this._loginInfoForPause = {appManager:appManager, email:email, password:password, didLogin:didLogin};
    var thisThing = this;
    NetworkManager.login(appManager, email, password, function(data)
    {
      didLogin(data);
    }, function(data)
    {
      thisThing._recursiveLoginTimeout = setTimeout(()=>
      {
        thisThing.recursiveLogin(appManager, email, password, didLogin);
      }, 1000)
    }, function(data)
    {
      thisThing._recursiveLoginTimeout = setTimeout(()=>
      {
        thisThing.recursiveLogin(appManager, email, password, didLogin);
      }, 1000)
    });
  },

  nameSubmit: function()
  {
    this._enableFirstNameError = true;
    this._enableLastNameError = true;
    var errors = this.checkErrors();

    if( !errors.firstNameError && !errors.lastNameError )
    {
      this.goToPage(1);
    }
    else
    {
      this.setState(errors);
    }
  },

  emailSubmit: function()
  {
    this._enableEmailError = true;
    var errors = this.checkErrors();

    if( !errors.emailError)
    {
      this.goToPage(1);
    }
    else
    {
      this.setState(errors);
    }
  },

  passwordSubmit: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var loggingInTitle = locManager.localizedStringForKey("LOGIN_SPINNER_TITLE");
    var loggingInBody = locManager.localizedStringForKey("LOGIN_SPINNER_BODY");
    this._enablePasswordError = true;
    var errors = this.checkErrors();

    if( !errors.passwordError)
    {
      this.showSpinnerAndMessage(loggingInTitle, loggingInBody);
      this.submitPressed();
    }
    else
    {
      this.setState(errors);
    }
  },

  forgotPassword: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var forgotPassTitle = locManager.localizedStringForKey("FORGOT_PASS_SPINNER_TITLE");
    var forgotPassBody = locManager.localizedStringForKey("FORGOT_PASS_SPINNER_BODY");
    this.showSpinnerAndMessage(forgotPassTitle, forgotPassBody);
  },

  loginComplete: function()
  {
    this.props.extras.didCompleteLogin();
  },

  render: function()
  {
    var createUser = this;
    var thisThing = this;
    var appManager = this.props.appManager;
    var featureData = appManager.getFeatureForName("SimpleLogin");
    var locManager = this.props.appManager.getLocalizationManager();
    var appInfo = appManager.getAppInfo();
    var tosLink = appManager.getTermsLink();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");

    var firstNameLabel = locManager.localizedStringForKey("FIRSTNAME_PLACEHOLDER");
    var lastNameLabel = locManager.localizedStringForKey("LASTNAME_PLACEHOLDER");
    var emailLabel = locManager.localizedStringForKey("USERNAME_PLACEHOLDER");
    var passwordLabel = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER");
    var registerButton = featureData.data.title;
    var refCodeButton = locManager.localizedStringForKey("REFERRAL_CODE_LABEL") + "?";
    var mailURL = "message://"
    var optInText = locManager.localizedStringForKeyAndParams("OPT_IN_CHECK", [appManager.appNameLong]);
    if( typeof optInText === 'undefined' || optInText == "OPT_IN_CHECK" )
    {
      optInText = "I’d like to receive exclusive deals from "+appManager.appNameLong+".";
    }

    var iconImageName = this.props.appManager.absoluteResourceForPath('App/iTunesArtwork.png');

    return (
      <OffsetView ref={(a) => { this._pageContainer = a }} horizontal={true} style={[styles.container, {height:this.props.initialLayout.height, backgroundColor: profileColor}]}>
        {
          this.state.shouldDrawPage[0] ?
            <View style={{padding:12, width:this.props.initialLayout.width, height:this.props.initialLayout.height, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}}>
              <View style={{margin:10}}>
                <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, color:profileTitleColor, textAlign:'center'}}>
                {locManager.localizedStringForKey("PLEASE_LOGIN_LABEL")}
                </ReUpText>
              </View>
              <View style={{flexDirection:'row', marginTop:10, marginLeft:10, marginRight:10, marginBottom:4}}>
                <ReUpField
                  invertBG={true}
                  appManager={appManager}
                  key="email" ref={(a) => { this._emailField = a }}
                  underlineColorAndroid='transparent'
                  autoCapitalize={'none'}
                  autoCorrect={false}
                  onFocus={()=>{thisThing.goToPage(0)}}
                  keyboardType={'email-address'}
                  onChangeText={this.emailChanged}
                  onSubmitEditing={() => {this.emailSubmit();}}
                  returnKeyType={'next'}
                  placeholder={emailLabel}
                  isInError={this.state.emailError}
                  style={[styles.textField]}/>
              </View>
              <View style={{height:26}}>
              {
                this.state.emailError ?
                  <ReUpText appManager={appManager} style={{color:'red', marginHorizontal:10}}>
                    {this.state.emailErrorString}
                  </ReUpText>
                : null
              }
              </View>
              <View style={{height:60, flexDirection:"row"}}>
              {
                this.state.showEmailDoneButton ?
                  <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("NEXT_BUTTON")} style={{margin:10, flex:1, alignSelf:'stretch'}} onPress={()=>
                    {
                      createUser.emailSubmit();
                    }}/>
                : null
              }
              </View>
            </View>
          : <View style={{width:this.props.initialLayout.width, height:this.props.initialLayout.height, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}} />
        }
        {
          this.state.shouldDrawPage[1] ?
            <View style={{padding:12, width:this.props.initialLayout.width, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}}>
              <View style={{margin:10}}>
                {
                  typeof this.props.extras !== 'undefined' && typeof this.props.extras.userName !== 'undefined' ?
                    <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, textAlign:'center'}}>
                    {
                      typeof this.props.extras.phoneNumber !== 'undefined' && this.props.extras.phoneNumber != null ?
                        "Please enter the password for \n"+this.props.extras.phoneNumber+":"
                      :
                        "Please enter the password for \n"+this.props.extras.userName+":"
                    }
                    </ReUpText>
                  :
                    <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, textAlign:'center'}}>
                    {locManager.localizedStringForKey("PLEASE_ENTER_PASS_LABEL")}
                    </ReUpText>
                }
              </View>
              <View style={{flexDirection:'row', marginTop:10, marginLeft:10, marginRight:10, marginBottom:4}}>
                <View style={{flexDirection:'column', flex:1}}>
                  <View style={styles.passwordContainer}>
                    <ReUpField
                      invertBG={true}
                      appManager={appManager}
                      underlineColorAndroid='transparent'
                      onChangeText={this.passwordChanged}
                      onSubmitEditing={this.state.showRefCode ? () => {this._ref_refCode.focus();} : this.passwordSubmit}
                      returnKeyType={this.state.showRefCode ? 'next' : 'done'}
                      key="password"
                      ref={(a) => { this._passwordField = a }}
                      onFocus={()=>{thisThing.goToPage(1)}}
                      isInError={this.state.passwordError}
                      placeholder={passwordLabel}
                      secureTextEntry={!this.state.showPassword}
                      style={[styles.textField]}/>

                    <MKIconToggle
                      style={{marginTop:22, height:30, width:30, position:'absolute', right:0, backgroundColor:'transparent'}}
                      checked={this.state.showPassword}
                      onCheckedChange=
                      {
                        this.state.showPassword ?
                        () => {createUser.setState({showPassword : false}); this._passwordField.onBlur(); this._passwordField.focus();}
                        :
                        () => {createUser.setState({showPassword : true}); this._passwordField.onBlur(); this._passwordField.focus();}
                      }
                      >
                      <Icon pointerEvents="none" state_checked={true} style={[styles.creditCardEditButtonIcon]} name={"eye"} size={14} color={generalTitleColor} />
                      <Icon pointerEvents="none" state_checked={false} style={[styles.creditCardEditButtonIcon]} name={"eye-slash"} size={14} color={generalTitleColor} />
                    </MKIconToggle>
                  </View>
                </View>
              </View>
              <View style={{height:26}}>
              {
                this.state.passwordError ?
                  <ReUpText appManager={appManager} style={{color:'red', marginHorizontal:10}}>
                    {locManager.localizedStringForKey("PASS_EIGHT_CHARACTERS_LOGIN_STATEMENT")}
                  </ReUpText>
                : null
              }
              </View>
              <View style={{height:60}}>
              {
                this.state.showPasswordDoneButton ?
                  <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("NEXT_BUTTON")} style={{margin:10, alignSelf:'stretch'}} onPress={()=>
                    {
                      createUser.passwordSubmit();
                    }}/>
                :
                  <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("FORGOT_PASS_BUTTON")} style={{margin:10, alignSelf:'stretch'}} onPress={()=>
                    {
                      createUser.forgotPassword();
                    }}/>
              }
              </View>
            </View>
          : <View style={{width:this.props.initialLayout.width, height:this.props.initialLayout.height, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}} />
        }
        {
          this.state.shouldDrawPage[2] ?
            <View style={{padding:12, width:this.props.initialLayout.width, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}}>
              <View style={{margin:10}}>
                <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, textAlign:'center'}}>
                {this.state.spinnerTitle}
                </ReUpText>
              </View>
              <View style={{margin:10}}>
                <ReUpText appManager={appManager} style={{color:profileTitleColor, textAlign:'center'}}>
                {this.state.spinnerBody}
                </ReUpText>
              </View>
              {
                this.state.shouldShowSpinner ?
                  <View ref={(c) => { this._ref_spinner = c; }} key="spinner" style={{height:60}}>
                    <MKSpinner strokeColor={[appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")]} style={{alignSelf:'center'}}/>
                  </View>
                : null
              }
            </View>
          : <View style={{width:this.props.initialLayout.width, height:this.props.initialLayout.height, flexDirection:'column', justifyContent:'center', alignItems:'stretch'}} />
        }
      </OffsetView>
    )
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignSelf:'stretch',
    alignItems: 'stretch',
    flexDirection: 'row',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  backgroundView: {
    position: 'absolute',
    top:0, left:0, bottom:0, top:0
  },
  textField: {
    flex:1
  },
  fieldsContainer: {
    flexDirection:'column',
    paddingHorizontal:16,
    paddingVertical:10
  },
  passwordContainer: {
    flexDirection:'row',
  },
  passwordShowButton: {
    borderRadius:25,
    width:50,
    height:50,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf:'center',
    margin:4
  },
  doneButton: {
    justifyContent:'center',
    flex:1,
    marginHorizontal:16,
    marginBottom:8
  },
});

SimpleLogin.dataDependencies = ["Users"];

module.exports = SimpleLogin;
